






import {Vue, Component, Prop} from 'vue-property-decorator'

@Component
export default class NcpColGroup extends Vue {
	@Prop() private data!: string[]

	private getWidth(w: string) {
		return {
			width: w
		}
	}
}

